/**
 * Composable untuk update meta tags
 * Simple approach tanpa library dependencies
 */
export function useMeta() {

  /**
   * Update meta title
   */
  const setTitle = (title) => {
    document.title = title;
    updateMetaTag('og:title', title);
    updateMetaTag('twitter:title', title);
  };

  /**
   * Update meta description
   */
  const setDescription = (description) => {
    updateMetaTag('description', description);
    updateMetaTag('og:description', description);
    updateMetaTag('twitter:description', description);
  };

  /**
   * Update meta image (OG image)
   */
  const setImage = (imageUrl) => {
    updateMetaTag('og:image', imageUrl);
    updateMetaTag('twitter:image', imageUrl);
  };

  /**
   * Update keywords
   */
  const setKeywords = (keywords) => {
    updateMetaTag('keywords', keywords);
  };

  /**
   * Update canonical URL
   */
  const setCanonical = (url) => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = url || window.location.href;
  };

  /**
   * Generic meta tag update
   */
  const updateMetaTag = (name, content) => {
    let element = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      if (name.startsWith('og:') || name.startsWith('twitter:')) {
        element.setAttribute('property', name);
      } else {
        element.setAttribute('name', name);
      }
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  /**
   * Inject JSON-LD schema
   */
  const setSchema = (schema) => {
    let script = document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  };

  /**
   * Update multiple meta tags at once
   */
  const updateMeta = (meta) => {
    if (meta.title) setTitle(meta.title);
    if (meta.description) setDescription(meta.description);
    if (meta.image) setImage(meta.image);
    if (meta.keywords) setKeywords(meta.keywords);
    if (meta.canonical) setCanonical(meta.canonical);
    if (meta.schema) setSchema(meta.schema);
    
    // Update og:url
    if (meta.url) {
      updateMetaTag('og:url', meta.url);
    }
  };

  /**
   * Track Meta Pixel events
   */
  const trackMetaEvent = (eventName, params = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, params);
    }
  };

  /**
   * Create a WhatsApp link with a contextual message
   */
  const buildWhatsAppLink = ({ title, service = '', source = 'website' }) => {
    const phone = '6285802956931';
    const packageLabel = title || 'paket outbound';
    const serviceLabel = service ? ` (${service})` : '';
    const message = `Halo Gaharu Outbound, saya tertarik dengan ${packageLabel}${serviceLabel}. Mohon info lebih lanjut.`;

    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}&source=${encodeURIComponent(source)}`;
  };

  return {
    setTitle,
    setDescription,
    setImage,
    setKeywords,
    setCanonical,
    updateMetaTag,
    setSchema,
    updateMeta,
    trackMetaEvent,
    buildWhatsAppLink,
  };
}
